module.exports = __webpack_public_path__ + "img/contact_wechat_qrcode_2.2da20b48.png";